'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record2;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getEditableLegalConsentKeysForLegalConsentType = getEditableLegalConsentKeysForLegalConsentType;

var _immutable = require('immutable');

var _I18n = require('I18n');

var _LegalConsent = require('../constants/LegalConsent');

var _underscore = require('underscore');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var keyedText = function keyedText(key, options) {
  return (0, _I18n.text)('gdpr.' + key, options);
};
var DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS = 'LEGITIMATE_INTEREST_PQL';

var DEFAULT_OPTIONS = {
  checkboxOptions: []
};

function getEditableLegalConsentKeysForLegalConsentType(legalConsentType) {
  switch (legalConsentType) {
    case _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT:
      return [_LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT, _LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, _LegalConsent.EditableLegalConsentKeys.PRIVACY_POLICY_TEXT, _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT];
    case _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT:
      return [_LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT, _LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT, _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT, _LegalConsent.EditableLegalConsentKeys.PRIVACY_POLICY_TEXT];
    case _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST:
      return [_LegalConsent.EditableLegalConsentKeys.SUBSCRIPTION_TYPES, _LegalConsent.EditableLegalConsentKeys.LAWFUL_BASIS, _LegalConsent.EditableLegalConsentKeys.PRIVACY_POLICY_TEXT];
    default:
      return [];
  }
}

var LegalConsent = function (_Record) {
  _inherits(LegalConsent, _Record);

  function LegalConsent() {
    _classCallCheck(this, LegalConsent);

    return _possibleConstructorReturn(this, (LegalConsent.__proto__ || Object.getPrototypeOf(LegalConsent)).apply(this, arguments));
  }

  _createClass(LegalConsent, [{
    key: 'addOrUpdateCommunicationCheckbox',
    value: function addOrUpdateCommunicationCheckbox(newCheckbox) {
      var oldCheckbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var currentCheckboxes = this.get(_LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES);
      var updatedCheckboxes = currentCheckboxes;

      if (!(0, _underscore.isEmpty)(oldCheckbox)) {
        var updateIndex = (0, _underscore.findIndex)(currentCheckboxes, { communicationTypeId: oldCheckbox.communicationTypeId });
        updatedCheckboxes = currentCheckboxes.map(function (value, index) {
          if (index === updateIndex) {
            return newCheckbox;
          }

          return value;
        });
      } else {
        updatedCheckboxes = currentCheckboxes.concat([newCheckbox]);
      }

      return this.set(_LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, updatedCheckboxes);
    }
  }, {
    key: 'removeCheckbox',
    value: function removeCheckbox(removedCheckbox) {
      var currentCheckboxes = this.get(_LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES);

      return this.set(_LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, currentCheckboxes.filter(function (_ref) {
        var communicationTypeId = _ref.communicationTypeId;
        return !(0, _underscore.isEqual)(removedCheckbox.communicationTypeId, communicationTypeId);
      }));
    }
  }, {
    key: 'getLegalConsentType',
    value: function getLegalConsentType() {
      var isLegitimateInterest = this.get(_LegalConsent.LegalConsentKeys.IS_LEGITIMATE_INTEREST);
      var processingConsentType = this.get(_LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TYPE);
      if (!isLegitimateInterest && processingConsentType === _LegalConsent.ProcessingConsentTypes.IMPLICIT) {
        return _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT;
      } else if (!isLegitimateInterest && processingConsentType === _LegalConsent.ProcessingConsentTypes.REQUIRED_CHECKBOX) {
        return _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT;
      } else if (isLegitimateInterest) {
        return _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST;
      }
      return _LegalConsent.LegalConsentOptions.NONE;
    }

    // Overite method to prevent arrays being cast to immutables

  }, {
    key: 'merge',
    value: function merge() {
      var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LegalConsent();

      var updatedRecord = (0, _underscore.values)(_LegalConsent.EditableLegalConsentKeys).reduce(function (memo, key) {
        if ((0, _underscore.isEmpty)(record.get(key)) || (0, _underscore.isEqual)(key, _LegalConsent.LegalConsentKeys.PRIVACY_POLICY_TEXT) || (0, _underscore.isEqual)(key, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TEXT)) {
          return memo;
        }

        return memo.set(key, record.get(key));
      }, this);

      return updatedRecord;
    }
  }], [{
    key: 'createLegalConsentFromOption',
    value: function createLegalConsentFromOption() {
      var _options;

      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT;
      var otherOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
      var checkboxOptions = otherOptions.checkboxOptions,
          companyName = otherOptions.domain;


      if (option === _LegalConsent.LegalConsentOptions.NONE) {
        return null;
      }

      var proccessingConsentType = option === _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT ? _LegalConsent.ProcessingConsentTypes.REQUIRED_CHECKBOX : _LegalConsent.ProcessingConsentTypes.IMPLICIT;

      var isLegitimateInterest = option === _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST;
      var processingConsentTextKey = option === _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT ? 'implicitProcessingConsentText' : 'explicitProcessingConsentText';
      var privacyPolicyKey = isLegitimateInterest ? 'legitimateInterestPrivacyPolicyText' : 'privacyPolicyText';

      var options = (_options = {}, _defineProperty(_options, _LegalConsent.LegalConsentKeys.IS_LEGITIMATE_INTEREST, isLegitimateInterest), _defineProperty(_options, _LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_TEXT, otherOptions[_LegalConsent.SettingsKeys.COMMUNICATION_CONSENT_TEXT] || keyedText('communicationConsentText', { companyName: companyName })), _defineProperty(_options, _LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, checkboxOptions), _defineProperty(_options, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TYPE, proccessingConsentType), _defineProperty(_options, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TEXT, otherOptions[processingConsentTextKey] || keyedText(processingConsentTextKey, { companyName: companyName })), _defineProperty(_options, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, otherOptions[_LegalConsent.SettingsKeys.EXPLICIT_PROCESSING_CONSENT_CHECKBOX_LABEL] || keyedText('explicitProcessingConsentCheckboxLabel', { companyName: companyName })), _defineProperty(_options, _LegalConsent.LegalConsentKeys.PRIVACY_POLICY_TEXT, otherOptions[privacyPolicyKey] || keyedText(privacyPolicyKey, { companyName: companyName })), _options);

      if (isLegitimateInterest && !(0, _underscore.isEmpty)(checkboxOptions)) {
        options[_LegalConsent.LegalConsentKeys.SUBSCRIPTION_TYPES] = [checkboxOptions[0].communicationTypeId];
      }

      return new LegalConsent(options);
    }
  }]);

  return LegalConsent;
}((0, _immutable.Record)((_Record2 = {}, _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.IS_LEGITIMATE_INTEREST, false), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_TEXT, ''), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, []), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TYPE, _LegalConsent.ProcessingConsentTypes.IMPLICIT), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TEXT, ''), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, ''), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT, ''), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.PRIVACY_POLICY_TEXT, ''), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.SUBSCRIPTION_TYPES, []), _defineProperty(_Record2, _LegalConsent.LegalConsentKeys.LAWFUL_BASIS, DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS), _Record2)));

exports.default = LegalConsent;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/FormsCommonComponents/static-1.726/js/lib/LegalConsent.js
// module id = 235
// module chunks = 0